<template>
  <div class="home">
    <div class="content">
      <!-- ============大图============ -->
      <div :class="isMobile?'phoneImg':'bigImg'" style="margin-top:1%;">
        <el-carousel height="415px" direction="horizontal" :autoplay="true" arrow="never">
          <el-carousel-item v-for="item in carouselData" :key="item.id">
            <img :src="`${item.fileUrl}`" width="100%" height="100%" alt="暂无图片">
            <!-- <img src="../assets/foot.png" width="100%" height="100%" alt=""> -->
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- ===================公司简介===================== -->
      <div :class="isMobile?'twoLine oneLine2':'twoLine oneLine'">
        <div class="leftpos">
          <div class="newsHeader">
            <div class="news_left">公司简介</div>
            <span @click="jump('1')">更多 <img src="../assets/jiantou.png" alt=""></span>
          </div>

          <div class="newsBody association">
            <div style="font-size:16px;">
              <p style="text-indent:2em;line-height:30px;">惠州市天宇信息技术有限公司成立于2013年，是一家专注于为政府及电力行业客户信息化建设提供解决方案和技术服务的高新信息技术企业。公司自成立以来以自主创新为发展动力，秉持“信心、诚实、卓越、分享”的企业理念，吸引了众多专业技术人才，为政府单位和电力行业客户提供定制化的信息化解决方案。</p>
              <p style="text-indent:2em;line-height:30px;">惠州市天宇信息技术有限公司作为一家高新技术企业，一直致力于技术创新和服务优化，为客户提供更加专业、高效的信息化解决方案，助力政府和电力行业实现数字化转型和发展。</p>
              <p style="text-indent:2em;line-height:30px;">惠州市天宇信息技术有限公司不仅致力于信息系统的研发和运维业务，还积极开拓大数据、深度学习和人工智能（AI）领域，进行新产品和新技术的研究与探索。公司在这些领域积累了丰富的研究成果，为客户提供更多创新的解决方案。通过不断探索和创新，公司不断提升自身的技术实力和服务水平，为行业发展和客户需求提供更好的支持与解决方案。</p>
              <!-- <p style="text-indent:2em;line-height:30px;">............</p> -->
            </div>
          </div>
        </div>

        <!-- ===============四个按钮区域============== -->
        <div class="openGo">
          <div class="c_button">
            <div class="c_butlist" @click="jump('1')"></div>
            <div class="c_butlist" @click="jump('1-2')"></div>
            <div class="c_butlist" @click="jump('2')"></div>
          </div>
        </div>
      </div>
      
      
    </div>

  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "Home",
  components:{
    vueSeamlessScroll
  },
  data() {
    return {
      // closeShow:false,
      // theDivShow:true,

      loading:true,
      classOption: {
        step: 0.5
      },
      logo: "",
      text: "test",
      show: false,
      firstItem:{},
      listdata: null,
      listDataNew:null,
      blanceImg: [],
      imgdata: [],
      allmsg: [],
      footimg: [],
      powerPage:{
        pageNum:"",
        limit:"",
        type: "2"
      },
      memberData:[],

      carouselData: [
        {fileUrl:require('../assets/logoGun.png')},
        {fileUrl:require('../assets/logoGun2.png')}
      ],

      listdataXxtz:[],
      isMobile:false
    };
  },
  created(){
    // debugger
    this.getScreen()
  },
  methods: {
    clearFdAd() {
        this.closeShow = true
    },
    starFdAd() {
        this.closeShow = false
    },
    getScreen() {
      if (
        navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      ) {
        this.isMobile = true;
        // console.log("手机");
      } else {
        this.isMobile = false;
        // console.log("pc");
      }
    },
    openUrl(url){
      // debugger
      // window.location.href= url
      // console.log(url.split('www'));
      if(url.substr(0,7).toLowerCase() == "http://"){
        window.open(`${url}`,"_block");
      }else{
        window.open(`http://${url}`,"_block");
      }
      // if (url.split('http')) {
      // }
    },
    jump(num) {
      // console.log(num,'num');
      if (num == 0) return;
      if (num == 1) this.$router.push({ path: "/IndustryProfile" ,query:{num:0}});
      if (num === '1-2') this.$router.push({ path: "/IndustryProfile",query:{num:1}});
      if (num === '2') this.$router.push({ path: "/IndustryTrends" ,query:{num:0}});
    },
  },
};
</script>
<style lang="less">
// #thediv {
//     z-index: 999999;
//     position:fixed;
//     top: 45%;
//     left: 15px;
//     // height: 100px;
//     height: 150px;
//     // width: 200px;
//     //overflow: hidden;

//     img {
//         width: 100%;
//         height: 100%;
//         image-rendering: -moz-crisp-edges; /* Firefox */
//         image-rendering: -o-crisp-edges; /* Opera */
//         image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
//         image-rendering: crisp-edges;
//         -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
//     }
// }

.el-loading-spinner {
  top:15% !important;
}
.bigImg {
    width: 1040px;
    height:415px;
    border: 2px solid rgba(225, 225, 225, 1);
    margin-left: 50%;
    transform: translate(-50%);
    .el-carousel__indicator--horizontal {
      left: 0px !important;
      margin-bottom: 20px !important;
    }
    .el-carousel__indicator--horizontal {
      padding: 12px 18px;
    }
  }
  .phoneImg {
    width: 732px;
    height:415px;
    border: 2px solid rgba(225, 225, 225, 1);
    margin-left: inherit;
    // transform: translate(-50%);
    .el-carousel__indicator--horizontal {
      left: 0px !important;
      margin-bottom: 20px !important;
    }
    .el-carousel__indicator--horizontal {
      padding: 12px 18px;
    }
  }
.home {
  display: flex;
  flex-direction: column;
}
.footimg2 {
  margin-top: 10px;
  margin-left: inherit;
  // transform: translate(-50%);
  // width: 968px;
  width: 1020px;
  height: 147px;
  img {
    width: 100%;
    height: 100%;
  }
}
.footimg {
  margin-top: 10px;
  margin-left: 50%;
  transform: translate(-50%);
  // width: 968px;
  width: 1020px;
  height: 147px;
  img {
    width: 100%;
    height: 100%;
  }
}
.foot_link2 {
  // width: 990px;
  width: 1045px;
  border: 1px solid rgba(225, 225, 225, 1);
  height: 50px;
  margin-left: inherit;
  // transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  img {
    width: 20%;
  }
  img:hover {
    cursor: pointer;
  }
}
.foot_link {
  // width: 990px;
  width: 1045px;
  border: 1px solid rgba(225, 225, 225, 1);
  height: 50px;
  margin-left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  img {
    width: 20%;
  }
  img:hover {
    cursor: pointer;
  }
}
@keyframes myfirst {
  from {
    left: 0;
  }
  to {
    left: -252%;
  }
}
.lunbo {
  background-color: white;
  // width: 990px;
  width: 1045px;
  // margin: 0 20%;
  margin-left:50%;
  transform: translate(-50%);
  border: 1px solid rgba(225, 225, 225, 1);
  overflow: hidden;
  margin-top: 20px;
  .l_frame {
    width: 100000px;
    height: 176px;
    position: relative;
    animation: myfirst 34s infinite linear;
    background-color: white;
  }
  .l_frame:hover {
    animation-play-state: paused;
  }
  li {
    float: left;
    width: 220px;
    height: 138px;
    list-style-type: none;
    margin: 8px 0;
    margin-left: 12px;
    img {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
    }
    label {
      position: relative;
      top: 5px;
      color: rgba(144, 147, 153, 1);
      font-size: 14px;
      left: 5px;
    }
  }
  li:hover {
    cursor: pointer;
  }
}
.lunbo2 {
  background-color: white;
  // width: 990px;
  width: 1045px;
  // margin: 0 20%;
  margin-left:inherit;
  // transform: translate(-50%);
  border: 1px solid rgba(225, 225, 225, 1);
  overflow: hidden;
  margin-top: 20px;
  .l_frame {
    width: 100000px;
    height: 176px;
    position: relative;
    animation: myfirst 34s infinite linear;
    background-color: white;
  }
  .l_frame:hover {
    animation-play-state: paused;
  }
  li {
    float: left;
    width: 220px;
    height: 138px;
    list-style-type: none;
    margin: 8px 0;
    margin-left: 12px;
    img {
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
    }
    label {
      position: relative;
      top: 5px;
      color: rgba(144, 147, 153, 1);
      font-size: 14px;
      left: 5px;
    }
  }
  li:hover {
    cursor: pointer;
  }
}
.oneLine2 {
  display: flex;
  justify-content: space-between;
  // width: 959px;
  width:1040px;
  height: 415px;
  // border:1px solid #ccc;
  margin-top:15px;
  // margin-left: inherit;
  // transform: translate(-50%);
  .leftpos {
    // padding: 0px 20%;
    // width: 645px;
    width: 705px;
    height: 100%;
    border: 1px solid rgba(225, 225, 225, 1);
    // margin-left: 50%;
    // transform: translate(-50%);
    .newsHeader {
      // width: 645px;
      width: 705px;
      height: 48px;
      // background-color: #f2f2f2;
      margin-bottom: 6px;
      border-bottom: 3px solid #31689b;
      .news_left {
        font-family:'微软雅黑';
        float: left;
        width: 200px;
        height: 50px;
        background-color:#31689b;
        color: #fff;
        font-size: 18px;
        line-height: 50px;
        text-align: center;
      }
      span {
        float: right;
        font-size: 14px;
        color:#c6c6c6;
        line-height: 50px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
        // font-weight: 700;
      }
    }
    .newsBody {
      display: flex;
      flex-direction: row;
      width: 100%;
      // height: 229px;
    }
    .association {
      display: flex;
      flex-direction: column;
      justify-content:space-around;
      padding:0 15px;
      box-sizing: border-box;
      div {
        margin-bottom: 10px;
      }
      .associationHd {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        span {
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd {
        font-size: 14px;
        color: #b0adad;
        text-indent: 2em;
        // width: 200px;
        span {
          overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        // display:block;
        // width: 615px;
        width: 680px;
        // height: 50px;
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd2 {
        display: flex;
        justify-content: space-around;
        // border:1px solid #ccc;
        // padding:0 15px;
        box-sizing: border-box;
        .left_b {
          padding-right: 15px;
          flex: 1;
          // margin-left:20px;
          // text-align: center;
          border-right: 1px solid rgba(225, 225, 225, 1);
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
        .right_b {
          flex: 1;
          margin-left:15px;
          // text-align: center;
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
      }
    }
  }
  .rightTops {
    width: 297px;
    height: 277px;
    // border: 1px solid #ccc;
    .policyHeader {
      width: 297px;
      height: 36px;
      background: url('../assets/policy.png') no-repeat;
      // background-color: #fff;
      .policy_left {
        float: left;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        // text-align: center;
        margin-left: 14%;
      }
      span {
        float: right;
        font-size: 12px;
        color:#c6c6c6;
        line-height: 36px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .policyBody {
      width: 297px;
      height: 236px;
      border: 1px solid rgba(225, 225, 225, 1);
      margin-top: 7px;
      padding: 0 10px;
      box-sizing: border-box;
        .seamless-warp {
        width: 100%;
        height: 217px;
        overflow: hidden;
        ul {
          color: #93969b;
          .icon_top {
            font-size: 12px;
            padding-left: 5px;
            padding-right: 6px;
            border: 1px solid rgba(179, 0, 0, 1);
            color: rgba(179, 0, 0, 1);
            border-radius: 4px;
          }
          .icon_top:active {
            color: none;
          }
          li {
            display: flex;
            align-items: center;
            justify-content:space-between;
            box-sizing: border-box;
            width: 100%;
            height: 14px;
            line-height: 32px;
            padding: 20px 0;
            list-style: none;
            border-bottom: 1px dashed rgba(225, 225, 225, 1);
            .right_go {
              float: left;
              width: 5px;
              height: 9px;
              // background-color: red;
              background: url('../assets/right.png') no-repeat;
            }
            .first_text {
              font-size: 14px;
              flex: 1;
              margin-left: 5px;
            }
            span {
              color: #3d3d3d;
            }
            .first_text:hover {
              cursor: pointer !important;
              text-decoration: underline !important;
              color: #30699b !important;
            }
            .first_text:active {
              color: #30699b;
            }
            .c_date {
              float: right;
              color: #999ca1;
              // margin-right: 15px;
            }
          }
          li:nth-child(1) {
            padding-top: 0;
            margin-top: 25px;
          }
        }
      }
    }
  }
}
.oneLine {
  display: flex;
  justify-content: space-between;
  // width: 959px;
  width:1040px;
  height: 415px;
  // border:1px solid #ccc;
  margin-top:15px;
  margin-left: 50%;
  transform: translate(-50%);
  .leftpos {
    // padding: 0px 20%;
    // width: 645px;
    width: 705px;
    // height: 277px;
    border: 1px solid rgba(225, 225, 225, 1);
    // margin-left: 50%;
    // transform: translate(-50%);
    .newsHeader {
      // width: 645px;
      width: 705px;
      height: 48px;
      // background-color: #f2f2f2;
      margin-bottom: 6px;
      border-bottom: 3px solid #31689b;
      .news_left {
        font-family:'微软雅黑';
        float: left;
        width: 200px;
        height: 50px;
        background-color:#31689b;
        color: #fff;
        font-size: 18px;
        line-height: 50px;
        text-align: center;
      }
      span {
        float: right;
        font-size: 14px;
        color:#c6c6c6;
        line-height: 50px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
        // font-weight: 700;
      }
    }
    .newsBody {
      display: flex;
      flex-direction: row;
      width: 100%;
      // height: 229px;
    }
    .association {
      display: flex;
      flex-direction: column;
      justify-content:space-around;
      padding:0 15px;
      box-sizing: border-box;
      div {
        margin-bottom: 10px;
      }
      .associationHd {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        span {
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd {
        font-size: 14px;
        color: #b0adad;
        text-indent: 2em;
        // width: 200px;
        span {
          overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        // display:block;
        // width: 615px;
        width: 680px;
        // height: 50px;
          &:hover{
            color: #e1a33d;
            cursor: pointer;
            text-decoration: underline
          }
        }
      }
      .associationBd2 {
        display: flex;
        justify-content: space-around;
        // border:1px solid #ccc;
        // padding:0 15px;
        box-sizing: border-box;
        .left_b {
          padding-right: 15px;
          flex: 1;
          // margin-left:20px;
          // text-align: center;
          border-right: 1px solid rgba(225, 225, 225, 1);
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
        .right_b {
          flex: 1;
          margin-left:15px;
          // text-align: center;
          ul {
            height: 120px;
            li {
              list-style: none;
              line-height: 30px;
              font-size: 14px;
              color: #454545;
              &:hover{
                cursor: pointer;
                color: #e1a33d;
              }
            }
          }
        }
      }
    }
  }
  .rightTops {
    width: 297px;
    height: 277px;
    // border: 1px solid #ccc;
    .policyHeader {
      width: 297px;
      height: 36px;
      background: url('../assets/policy.png') no-repeat;
      // background-color: #fff;
      .policy_left {
        float: left;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
        // text-align: center;
        margin-left: 14%;
      }
      span {
        float: right;
        font-size: 12px;
        color:#c6c6c6;
        line-height: 36px;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .policyBody {
      width: 297px;
      height: 236px;
      border: 1px solid rgba(225, 225, 225, 1);
      margin-top: 7px;
      padding: 0 10px;
      box-sizing: border-box;
        .seamless-warp {
        width: 100%;
        height: 217px;
        overflow: hidden;
        ul {
          color: #93969b;
          .icon_top {
            font-size: 12px;
            padding-left: 5px;
            padding-right: 6px;
            border: 1px solid rgba(179, 0, 0, 1);
            color: rgba(179, 0, 0, 1);
            border-radius: 4px;
          }
          .icon_top:active {
            color: none;
          }
          li {
            display: flex;
            align-items: center;
            justify-content:space-between;
            box-sizing: border-box;
            width: 100%;
            height: 14px;
            line-height: 32px;
            padding: 20px 0;
            list-style: none;
            border-bottom: 1px dashed rgba(225, 225, 225, 1);
            .right_go {
              float: left;
              width: 5px;
              height: 9px;
              // background-color: red;
              background: url('../assets/right.png') no-repeat;
            }
            .first_text {
              font-size: 14px;
              flex: 1;
              margin-left: 5px;
            }
            span {
              color: #3d3d3d;
            }
            .first_text:hover {
              cursor: pointer !important;
              text-decoration: underline !important;
              color: #30699b !important;
            }
            .first_text:active {
              color: #30699b;
            }
            .c_date {
              float: right;
              color: #999ca1;
              // margin-right: 15px;
            }
          }
          li:nth-child(1) {
            padding-top: 0;
            margin-top: 25px;
          }
        }
      }
    }
  }
}
.twoLine {
  // border: 1px solid #ccc;
  .openGo {
    width: 297px;
    height: 60%;
    // border: 1px solid #ccc;
  }
}
label > span:nth-child(1) {
  cursor: pointer;
}
label span:hover {
  color: rgb(21, 71, 119);
}
.test {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 30px;
  width: 260px;
  background-color: rgba(0, 54, 137, 0.58);
  line-height: 47px;
  color: white;
  text-align: left;
  padding-left: 10px;
  label {
    font-size: 16px;
    // font-weight: 900;
  }
}
.el-carousel__indicator--horizontal {
  border-radius: 50% !important;
  position: relative !important;
  left: 280px !important;
}
.el-carousel__button {
  height: 10px !important;
  width: 10px !important;
  border-radius: 50% !important;
}
/* 中间内容 start*/
.content {
  width: 100%;
  min-width: 1260px;
  // padding-top: 193px;
}
.c_rotation {
  // float: left;
  height: 217px;
  width: 260px;
  min-width: 260px;
  margin: 0 8px;
  // margin-left: 351px;
  // margin-left:20%;
  .el-carousel__indicator--horizontal{
    left: 0px !important;
  }
}
.c_rotation {
  img {
    width: 260px;
    height: 217px;
  }
}
.c_rightmes {
  // float: left;
  height: 217px;
  // margin-left: 18px;
}
.c_mes {
  // background: black;
  box-sizing: border-box;
  // border: 1px #ececec solid;
  // width: 362px;
  width: 410px;
  height: 217px;
  padding-left: 15px;
  .seamless-warp {
    width: 100%;
    height: 217px;
    overflow: hidden;
    ul {
      color: #93969b;
      .icon_top {
        font-size: 12px;
        padding-left: 5px;
        padding-right: 6px;
        border: 1px solid rgba(179, 0, 0, 1);
        color: rgba(179, 0, 0, 1);
        border-radius: 4px;
      }
      .icon_top:active {
        color: none;
      }
      li {
        display: flex;
        align-items: center;
        justify-content:space-between;
        box-sizing: border-box;
        width: 100%;
        height: 14px;
        line-height: 32px;
        padding: 20px 0;
        list-style: none;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        .right_go {
          float: left;
          width: 5px;
          height: 9px;
          // background-color: red;
          background: url('../assets/right.png') no-repeat;
        }
        .first_text {
          font-size: 14px;
          flex: 1;
          margin-left: 5px;
        }
        span {
          color: #3d3d3d;
        }
        .first_text:hover {
          cursor: pointer;
          text-decoration: underline;
          color: #30699b;
        }
        .first_text:active {
          color: #30699b;
        }
        .c_date {
          float: right;
          color: #999ca1;
          // margin-right: 15px;
        }
      }
      li:nth-child(1) {
        padding-top: 0;
        margin-top: 20px;
      }
    }
  }
  
}

.c_mes2 {
  padding-left: 15px;
  width: 100%;
  height: 190px;
  border: none;
  border:1px solid rgba(225, 225, 225, 1);
  overflow: hidden;
  ul {
    width: 100%;
    height: 100%;
    padding:9px 0;
    li {
      font-size: 14px;
      list-style: none;
      padding-bottom:17px;
      &:last-child{
        padding-bottom:0;
      }
      span:hover {
        color: #30699b;
        cursor: pointer;
        text-decoration: underline
      }
    }
  }
}
.c_button {
  width: 100%;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  align-items: center;
  // margin-top: 12px;
  text-align: center;
  font-weight: 1000;
  line-height: 48px;
  color: #30699b;

}
.c_butlist {
  font-size: 16px;
  background: #f5f5f5;
  width: 305px;
  height: calc(100% / 3);
  margin-top:14px;
  &:nth-child(1) {
  margin-top:0px;
    color: #c3892a;
    background: url('../assets/examination.png') no-repeat;
    background-size:100% 100%;
    background-attachment:fixed;
    &:hover{
      cursor: pointer;
      color: #ec9508;
    }
  }
  &:nth-child(2) {
    color: #d4875d;
    background: url('../assets/portal.png') no-repeat;
    background-size:100% 100%;
    background-attachment:fixed;
    &:hover{
      cursor: pointer;
      color: #e75506;
    }
  }
  &:nth-child(3) {
    color: #387eae;
    background: url('../assets/recruitment.png') no-repeat;
    background-size:100% 100%;
    background-attachment:fixed;
    &:hover{
      cursor: pointer;
      color: #00406a;
    }
  }
}
// .c_butlist:hover {
//   cursor: pointer;
//   color: rgb(21, 71, 119);
// }
// .c_left {
//   margin-left: 11px;
// }
.c_noticebox2 {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  // width: 959px;
  width: 1020px;
  // float: left;
  margin-left:inherit;
  // transform: translate(-50%);
  // margin: 0px 350px;
  // padding-left: 350px;
  // padding: 0 20%;
  display: flex;
  flex-direction: row;
  .c_row {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    height: 33px;
    width: 100%;
    // border-bottom: 3px solid #31689b;
    justify-content: space-between;
    margin-bottom:10px;
  }
  .c_noticetext {
    box-sizing: border-box;
    line-height: 33px;
    font-size: 12px;
    margin-right: 16px;
    color: #c6c6c6;
  }
  .c_noticetext:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .c_frame {
    // border: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-top: 21px;
    // width: 293px;
    width: 330px;
    height: 226px;
    background:url('../assets/BottomColumn.png') no-repeat;
    .c_noticelefttop {
      box-sizing: border-box;
      width: 98px;
      height: 33px;
      // background-color: #31689b;
      text-align: center;
      line-height: 33px;
      color: #2971b4;
      font-weight: 700;
      font-size: 14px;
      margin-bottom:10px;
    }
  }
}
.c_noticebox {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  // width: 959px;
  width: 1020px;
  // float: left;
  margin-left:50%;
  transform: translate(-50%);
  // margin: 0px 350px;
  // padding-left: 350px;
  // padding: 0 20%;
  display: flex;
  flex-direction: row;
  .c_row {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    height: 33px;
    width: 100%;
    // border-bottom: 3px solid #31689b;
    justify-content: space-between;
    margin-bottom:10px;
  }
  .c_noticetext {
    box-sizing: border-box;
    line-height: 33px;
    font-size: 12px;
    margin-right: 16px;
    color: #c6c6c6;
  }
  .c_noticetext:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .c_frame {
    // border: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-top: 21px;
    // width: 293px;
    width: 330px;
    height: 226px;
    background:url('../assets/BottomColumn.png') no-repeat;
    .c_noticelefttop {
      box-sizing: border-box;
      width: 98px;
      height: 33px;
      // background-color: #31689b;
      text-align: center;
      line-height: 33px;
      color: #2971b4;
      font-weight: 700;
      font-size: 14px;
      margin-bottom:10px;
    }
  }
}
// .c_noticebox > div:nth-last-child(1) {
//   margin-left: 22px;
// }
.c_img {
  box-sizing: border-box;
  float: left;
  // margin-left: 353px;
  // margin: 0px 350px;
  margin: 0 20%;
  height: 130px;
  width: 59%;
  margin-top: 21px;
  background-color: #a4ccee;
  border: 1px #ececec solid;
}

/* 中间内容 end*/
</style>
<style>
</style>
